module.exports = __webpack_public_path__ + "media/images/sample_img04-2bc81a8f83a4a639a439df41dfec3809.png";